import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Table, Button } from 'antd';
import styled from './styled';
const { flexEnd, mr } = styled;
export let setGetSortRows , setSortColumn ;
import  { handleSortPopup } from './index'

const defaultProps = {
  listenSort : null
}

const Sort = ({ details, listenSort }) => {

  const [data, setData] = useState(details);
  const [columns, setColumns] = useState([]);

  setGetSortRows = (newData) => {
    setData(newData);
    return () => data
  }

  setSortColumn = (newColumns) => {
    setColumns(newColumns)
  }
  

  const footerTemplate = (dataObj) => () => {

    const handleCancle = () => {
      handleSortPopup()
    } 
    const handleApply = () => listenSort(dataObj);

    return (
      <div style={flexEnd}>
        <Button type='default' onClick={handleCancle} >Cancel</Button>
        <div style={mr} />
        <Button type='primary' onClick={handleApply} >Apply</Button>
      </div>
    )
  }


  return (
    <div style={{minWidth: '505px'}}>
      <Table pagination={false}  columns={columns} dataSource={data} bordered
        footer={footerTemplate(data)} />
    </div>
  )
}

Sort.defaultProps = defaultProps;
Sort.propTypes = {
  listenSort: PropTypes.func
}
export default Sort
